import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from '@app/App';
import { initSentry } from '@lib/sentry';
import { installRechartsWarningFilter } from '@lib/suppressRechartsWarning';
import { installChunkReloadRecovery } from '@lib/chunkReloadRecovery';
import './index.css';

initSentry();
installRechartsWarningFilter();
installChunkReloadRecovery();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
